import { gql } from '@apollo/client';

export const CURRENT_QUESTIONS = gql`
  query currentQuestions {
    currentSurvey {
      survey {
        id
      }
      questions {
        id
        attributes {
          question
          scale {
            data {
              attributes {
                options {
                  scale
                  option
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const MUTATION_SUBMIT_ANSWER = gql`
  mutation submitAnswer($data: AnswerInput!) {
    createAnswer(data: $data) {
      data {
        attributes {
          createdAt
        }
      }
    }
  }
`;

export const MUTATION_SUBMIT_SURVEY_USERS = gql`
  mutation submitSurveyUser($data: SurveyUserInput!) {
    createSurveyUser(data: $data) {
      data {
        attributes {
          createdAt
        }
      }
    }
  }
`;
